// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"SkeletonLoader_skeleton__kmtTF","shimmer":"SkeletonLoader_shimmer__wia39"};